import React from "react"

import "./src/styles/global.scss"
import Home from "./src/components/pages/home"


// Logs when the client route changes
// exports.onRouteUpdate = ({ location, prevLocation }) => {
//  console.log("new pathname", location.pathname)
//  console.log("old pathname", prevLocation ? prevLocation.pathname : null)
// }

// Wraps every page in a component
export const wrapPageElement = ({ element }) => {
    return(
        <Home>
            {element}
        </Home>
    )
}